import Content from 'services/Content';
import {
  TRADITIONAL_IRA,
  ROLLOVER_IRA,
  TRADITIONAL_IRA_BENE_DEATH,
  ROTH_ROLLOVER_IRA,
  ROTH_IRA_BENE_DEATH,
  ROTH_IRA
} from 'services/AccountTypes';
import {
  DISTRIBUTE_TO_BANK_ID,
  DISTRIBUTE_TO_FUND_ID
} from 'services/Preferences';

export const disclosureCopyAccountType = (accountTypeId) => {
  return ((accountTypeId === TRADITIONAL_IRA || accountTypeId === ROLLOVER_IRA ||
    accountTypeId === TRADITIONAL_IRA_BENE_DEATH) ?
    Content.withholdingDisclosureRI2020Copy
    : (accountTypeId === ROTH_IRA || accountTypeId === ROTH_ROLLOVER_IRA || accountTypeId === ROTH_IRA_BENE_DEATH) ?
      Content.withholdingDisclosureRI2020RothCopy
      : Content.withholdingDisclosureCopy);
};

export const disclosureTitle = (accountTypeId) => {
  return ((accountTypeId === TRADITIONAL_IRA || accountTypeId === ROLLOVER_IRA ||
    accountTypeId === TRADITIONAL_IRA_BENE_DEATH || accountTypeId === ROTH_IRA ||
    accountTypeId === ROTH_ROLLOVER_IRA || accountTypeId === ROTH_IRA_BENE_DEATH) ?
    'Federal Income Tax Withholding'
    : 'Income Tax Withholding Disclosure');
};

export const hasDistributionOptionChanged = (distribution, originalDistribution, fund, bank) => {
  if(distribution && originalDistribution) {
    const { distributionTypeId } = distribution;
    const { distributionTypeId: originalDistributionTypeId } = originalDistribution;

    if(distributionTypeId === DISTRIBUTE_TO_FUND_ID && originalDistributionTypeId === DISTRIBUTE_TO_FUND_ID) {
      if(fund && originalDistribution.fund) {
        const { accountDescriptor: { accountId } } = fund;
        const { fund: { accountDescriptor: { accountId: originalAccountId } } } = originalDistribution;
        return accountId !== originalAccountId;
      }
    }

    if(distributionTypeId === DISTRIBUTE_TO_BANK_ID && originalDistributionTypeId === DISTRIBUTE_TO_BANK_ID) {
      if(bank && originalDistribution.bankAgreementKey) {
        const { bankId } = bank;
        const { bankAgreementKey: { bankId: originalBankId } } = originalDistribution;
        return bankId !== originalBankId;
      }
    }

    return distributionTypeId !== originalDistributionTypeId;
  }

  return false;
};

// Check if distribution option has changed - Valid to use for Dividends or Capital Gains
// If distributionTypeId is Distribute to Fund or Bank, it checks that a fund or bank has  been selected
export const hasDistributionOptionChanged2 = (
  distributionTypeId,
  originalDistributionTypeId,
  fund,
  originalFund,
  bankKey,
  originalBankKey
) => {
  if(distributionTypeId && originalDistributionTypeId) {

    if(distributionTypeId === DISTRIBUTE_TO_FUND_ID && originalDistributionTypeId === DISTRIBUTE_TO_FUND_ID) {
      if(fund && originalFund) {
        return fund !== originalFund;
      }
    }

    if(distributionTypeId === DISTRIBUTE_TO_BANK_ID && originalDistributionTypeId === DISTRIBUTE_TO_BANK_ID) {
      if(bankKey && originalBankKey) {
        return bankKey !== originalBankKey;
      }
    }

    return distributionTypeId !== originalDistributionTypeId;
  }

  return false;
};
